export default function() {
  return [
    {
      title: "Home",
      to: {
        name: "dashboard"
      },
      htmlBefore: '<i class="material-icons">home</i>',
      htmlAfter: ""
    },

    {
      title: "To Dos",
      htmlBefore: '<i class="material-icons">check_circle</i>',
      to: {
        name: "todos"
      }
    },
    {
      title: "Supporters",
      htmlBefore: '<i class="material-icons">people</i>',
      to: {
        name: "supporters"
      }
    },
    {
      title: "Actions",
      htmlBefore: '<i class="material-icons">call_to_action</i>',
      to: {
        name: "ctas"
      }
    },
    {
      title: "Import",
      htmlBefore: '<i class="material-icons">cloud_upload</i>',
      to: {
        name: "Contacts"
      }
    },
    {
      title: "Settings",
      htmlBefore: '<i class="material-icons">settings</i>',
      to: {
        name: "setup"
      }
    }
  ];
}
